<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewAMAliases.title") }}
      <v-btn
          color="success"
          class="ml-1 green-shadow"
          x-small
          fab
          max-width="26"
          max-height="26"
          @click.stop="dialogAdd.visible=true; dialogAdd.type='brand';newBrandOrAlias.type = 'brand'"
          :title="$t('viewAMAliases.add_mark')"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h3>
    <v-toolbar elevation="0" dense rounded class="mt-3">
      <v-toolbar-items>
        <v-btn small text :to="{name:'am-search'}" exact>{{ $t("navigation.am_search") }}</v-btn>
        <v-btn small text :to="{name:'am-crosses'}"> {{ $t('navigation.crosses')}}</v-btn>
        <v-btn small text :to="{name:'am-aliases'}"> {{ $t('navigation.aliases')}}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout class="pa-3 pt-0">
      <v-flex xs12>
        <v-row>
          <v-col cols="12" class="d-flex justify-end text-right py-2 pb-1 pr-0" sm="12" md="12">
            <v-spacer></v-spacer>
            <v-btn
                color="warning"
                class="mt-3 mr-2 elevation-0"
                @click="restoreSettings"
            >
              {{ $t('viewAMAliases.restore_default_settings') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-row class="mx-0 w-100">
        <v-col md="6" xs="12" class="px-0">
          <v-card class="px-3 py-2 ma-0" elevation="0">
            <v-row ma-0>
              <v-col cols="12" class="" ref="levamAmSearchWrap">
                <v-autocomplete
                    autocomplete="off"
                    hide-details
                    v-model="currentBrandOrAlias"
                    outlined
                    clear-icon="fa-times"
                    clearable
                    :items="items"
                    @click:clear="clearCurrentBrandOrAlias"
                    :loading="isLoading"
                    :search-input.sync="autocompleteText"
                    @input="getData"
                    @change="getData"
                    item-text="name"
                    item-value="name"
                    :no-data-text="noDataText"
                    :placeholder="$t('common.start_typing_to_search')"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="px-3 py-2 ma-0 mt-8" elevation="0" v-if="finded.brand!==null">
            <h2 class="mt-0 ml-0 mb-2">
              <span
                  :class="{ 'blue--text': (!finded.brand || finded.brand.toUpperCase() === currentBrandOrAlias.toUpperCase()), 'removed':finded.is_deleted_brand}">
                {{ finded.brand }}
              </span>
              <v-tooltip top v-if="!finded.is_deleted_brand">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn icon ripple @click.stop="" class="ml-2" @click="deleteAliasOrBrand('brand', finded.brand)">
                      <v-icon small color="red lighten-1">fa-trash</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ $t('viewAMAliases.delete_mark') }}</span>
              </v-tooltip>
              <v-tooltip top v-if="finded.is_deleted_brand">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn icon ripple @click.stop="" class="ml-2" @click="restoreBrand(finded.brand)">
                      <v-icon small color="grey lighten-1">fa-trash-restore</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>{{ $t('common.restore') }}</span>
              </v-tooltip>
            </h2>
            <strong>{{ $t('common.aliases') }}</strong>
            <v-btn
                color="success"
                class="ml-1 green-shadow"
                x-small
                fab
                max-width="26"
                max-height="26"
                @click.stop="dialogAdd.visible=true; dialogAdd.type='alias'; newBrandOrAlias.type = 'alias'"
            >
              <v-icon x-small>$plus</v-icon>
            </v-btn>
            <v-list max-width="800">
              <v-list-item
                  :key="i"
                  v-for="(alias, i) in aliases"
                  class="ma-0 pa-0 tree"
                  @click=""
              >
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class="ma-0 pa-0">
                    <span
                        :class="{ 'blue--text': alias.toUpperCase() === currentBrandOrAlias.toUpperCase(), 'removed':deletedAliases.includes(alias.toUpperCase())}">{{
                        alias
                      }}</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="ma-0">
                  <v-item-group v-if="deletedAliases.includes(alias.toUpperCase())">
                    <v-tooltip top v-if="deletedAliasesTypes[alias].type=='deleted'">
                      <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    <v-btn icon ripple @click.stop="" class="ml-2 mr-2"
                                           @click="restoreAlias(finded.brand, alias)">
                                      <v-icon small color="grey lighten-1">fa-trash-restore</v-icon>
                                    </v-btn>
                                  </span>
                      </template>
                      <span>{{ $t('common.restore') }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="deletedAliasesTypes[alias].type=='local_alias'">
                      <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    <v-btn icon ripple @click.stop="" class="ml-2  mr-2">
                                      <v-icon color="grey lighten-1">not_interested</v-icon>
                                    </v-btn>
                                  </span>
                      </template>
                      <span>{{ $t('viewAMAliases.used_as_local_alias') }} {{ deletedAliasesTypes[alias].parent_brand }} </span>
                    </v-tooltip>
                    <v-tooltip top v-if="deletedAliasesTypes[alias].type=='local_brand'">
                      <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    <v-btn icon ripple @click.stop="" class="ml-2 mr-2">
                                      <v-icon color="grey lighten-1">highlight_off</v-icon>
                                    </v-btn>
                                  </span>
                      </template>
                      <span>{{ $t('viewAMAliases.used_as_local_brand') }} </span>
                    </v-tooltip>
                  </v-item-group>
                  <v-item-group v-else>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                   <v-btn icon ripple @click.stop="" @click="deleteAliasOrBrand('alias', alias)"
                                          class="ml-2 mr-2">
                                      <v-icon small color="red lighten-1">fa-trash</v-icon>
                                    </v-btn>
                                  </span>
                      </template>
                      <span>{{ $t('common.remove') }}</span>
                    </v-tooltip>
                  </v-item-group>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-btn
                v-if="aliases.length > 10"
                tile
                outlined
                color="green"
                @click.stop="dialogAdd.visible=true; dialogAdd.type='alias'; newBrandOrAlias.type = 'alias'"
                class="mx-0 mt-0 mb-3 align-content-end"
                :disabled="finded.is_deleted_brand"
            >
              <v-icon small left color="green lighten-1">
                fa-plus
              </v-icon>
              {{ $t('viewAMAliases.add_alias') }}
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>

    <v-dialog v-model="dialogAdd.visible" persistent scrollable max-width="600px">
      <v-card>
        <v-card-text class="ma-0 pa-3">
          <div class="pa-3">
            <v-text-field
                v-if="dialogAdd.type==='brand'"
                v-model="newBrandOrAlias.brand"
                :label="$t('viewAMAliases.brand')"
                :placeholder="$t('viewAMAliases.enter_brand_name')"
                clearable
                outlined
            ></v-text-field>
            <v-text-field
                v-if="dialogAdd.type==='alias'"
                v-model="newBrandOrAlias.alias"
                :label="$t('viewAMAliases.alias')"
                :placeholder="$t('viewAMAliases.enter_alias_name')"
                outlined
                clearable
                hide-details
                class="mt-3"
            ></v-text-field>
            <v-card-actions class="pa-0 mt-3">
              <v-spacer></v-spacer>
              <v-btn
                  color="danger"
                  elevation="0"
                  @click="dialogAdd.visible = false; newBrandOrAlias.brand=''; newBrandOrAlias.alias='';"
                  class="white--text"
              >
                {{ $t('common.cancel') }}
              </v-btn>
              <v-btn
                  color="primary"
                  class="mr-0"
                  elevation="0"
                  @click="addNew"
              >
                {{ $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import {mapFields} from 'vuex-map-fields';

axios.defaults.withCredentials = true;


export default {
  data: () => ({
    restoreSettingsConfirmDialog: false,
    findTimeoutId: null,
    dialogAdd: {
      visible: false,
      type: 'brand'
    },
    newBrand: '',
    newAlias: ''
  }),
  mounted() {

  },
  watch: {
    autocompleteText(val2, val1) {
      if (this.isLoading) return;
      if (val2 === null) return;
      if (val2 === undefined) return;
      if (val2.trim() === '') return;
      val2 = val2.toUpperCase();
      if (val1 !== null && val1 !== '') val1 = val1.toUpperCase();
      if (this.entries.indexOf(val2) > -1) {
        return this.getData();
      } else {
      }
      if (val1 == val2) return;
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.$store.dispatch('am_aliases/autocomplete');
        clearTimeout(this.findTimeoutId);
      }, 1000);

    }
  },
  computed: {
    ...mapFields('am_aliases',
        [
          'isLoading',
          'finded',
          'entries',
          'count',
          'currentBrandOrAlias',
          'autocompleteText',
          'newBrandOrAlias'
        ]
    ),
    noDataText() {
      return this.isLoading ? '...' : this.$t('common.no_data_available');
    },
    items() {
      if (this.entries.length < 1) return [];
      return this.entries.map(entry => {
        return {name: entry, text: entry};
      });
    },
    aliases() {
      let data = this.finded.aliases;
      if (this.finded) {
        if (this.finded.deleted.length > 0) {
          for (let i in this.finded.deleted) {
            data.push(this.finded.deleted[i].name);
          }
        }
      }
      return data.filter(alias => alias != '#' && alias != '#deleted');
    },
    deletedAliasesTypes() {
      let data = {};
      if (this.finded) {
        if (this.finded.deleted.length > 0) {
          for (let i in this.finded.deleted) {

            data[this.finded.deleted[i]['name']] = this.finded.deleted[i];

          }
        }
      }
      return data;
    },
    deletedAliases() {
      if (this.finded) {
        if (this.finded.deleted.length > 0) {
          return this.finded.deleted.map((item) => {
            return item['name'];
          });
        }
      }
      return [];

    },
    tableHeader() {

    },
    language() {
      return this.lang;
    }
  },
  methods: {
    getData() {
      if (!this.currentBrandOrAlias) return;
      this.$store.dispatch('am_aliases/getData');
    },
    restoreSettings() {
      this.$store.dispatch('am_aliases/restoreSettings').then((response) => {
        if (response == 'success') {
          this.getData();
          this.$inform(this.$t('viewAMAliases.success_restored_default'));
        }
      })
    },
    addNew() {
      this.$store.dispatch('am_aliases/addNew').then((response) => {
        if (response == 'success') {
          this.getData();
          this.dialogAdd.visible = false;
        }
      })
    },
    clearCurrentBrandOrAlias() {
      this.entries = [];
      this.finded = {
        'aliases': '',
        'brand': null,
        'deleted': []
      };
    },
    deleteAliasOrBrand(type, title) {
      this.$store.dispatch('am_aliases/delete', {
        'type': type,
        'title': title,
      }).then((response) => {
        if (response == 'success') {
          this.getData();
          this.$inform(this.$t('common.success_remove'));
        }
      })
    },
    restoreAlias(brand, alias) {
      this.$store.dispatch('am_aliases/restore', {
        'title': alias,
        'type': 'alias',
      }).then((response) => {
        if (response == 'success') {
          this.getData();
          this.$inform(this.$t('common.success_restore'));
        }
      });

    },
    restoreBrand(brand) {

      this.$store.dispatch('am_aliases/restore', {
        'title': brand,
        'type': 'brand',
      }).then((response) => {
        if (response == 'success') {
          this.getData();
          this.$inform(this.$t('common.success_restore'));
        }
      });
    }
  }
}
</script>

<style>
.v-application .v-list-item__title .removed {
  text-decoration: line-through;
  color: gray !important;
}

.v-list {
  margin-left: 3px;
}

.v-list .tree:after {
  display: block;
  height: 47px;
  width: 1px;
  content: '';
  border: 1px solid gray;
  position: absolute;
  margin-left: -1px;
  margin-top: -23px;
  opacity: 1;
}

.v-list .tree:first-child:after {
  height: 30px;
  margin-top: -14px;
}

.v-list .tree .v-list-item__title span {
  padding-left: 15px;
}

.v-list .tree .v-list-item__title:after {
  display: block;
  height: 18px;
  width: 1px;
  content: '';
  border: 1px solid gray;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  margin-left: 7px;
  position: absolute;
  margin-top: -18px;
}
</style>
